// Angular
import { Injectable, OnDestroy, OnInit } from '@angular/core';

// Models
import { AppCleanup } from '../models';

@Injectable({
	providedIn: 'root',
})
export class BroadcastChannelService extends AppCleanup implements OnInit, OnDestroy {
	broadcastChannel: BroadcastChannel;

	constructor() {
		super();
		this.broadcastChannel = new BroadcastChannel('demo-broadcast-channel');
	}

	ngOnDestroy() {
		super.ngOnDestroy();
		if (this.broadcastChannel) {
			this.broadcastChannel.close();
		}
	}

	startSendingMessages() {
		let i: number = 1;
		setInterval((x) => {
			this.broadcastChannel.postMessage({
				type: 'counter',
				counter: i,
			});
			i++;
		}, 1000);
	}
}
